// Browsers without the command/commandfor button attributes would leave every "show-modal" and
// "close" button dead, the navbar Log in among them, so open and close the dialog by hand there.
export const handleCommandClick = (event) => {
  const button = event.target.closest?.('button[commandfor]')
  if (!button || button.disabled) return

  const dialog = document.getElementById(button.getAttribute('commandfor'))
  if (!(dialog instanceof HTMLDialogElement)) return

  const command = button.getAttribute('command')
  if (command === 'show-modal' && !dialog.open) dialog.showModal()
  if (command === 'close' && dialog.open) dialog.close()
}

export const initInvokerCommandsFallback = () => {
  if ('commandForElement' in HTMLButtonElement.prototype) return

  document.addEventListener('click', handleCommandClick)
}
